import { useState } from 'react';
import { Btn } from '../../ui';

export const DangerZoneSection = () => {
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [confirmText, setConfirmText] = useState('');
    const isConfirmValid = confirmText === 'DEACTIVATE';

    return (
        <>
            <section className="settings-section settings-section--danger">
                <div className="danger-zone-header">
                    <h2 className="danger-zone-title">Danger Zone</h2>
                    <p className="danger-zone-desc">
                        Deactivating your account will permanently delete all data, including equipment records, inspection history, and accounts. This cannot be undone.
                    </p>
                </div>
                <Btn
                    variant="danger"
                    buttonSize="sm"
                    buttonText="Deactivate Account"
                    buttonOnClick={() => setShowDeactivateModal(true)}
                />
            </section>

            {/* Deactivate Confirmation Modal */}
            {showDeactivateModal && (
                <div className="modal-overlay" onClick={() => setShowDeactivateModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header modal-header-danger">
                            <h2>Deactivate Account</h2>
                            <button className="modal-close" onClick={() => setShowDeactivateModal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <div className="modal-warning">
                                <p>
                                    <strong>This action is permanent and cannot be undone.</strong> Deactivating your account will:
                                </p>
                                <ul>
                                    <li>Delete all equipment records and inspection history</li>
                                    <li>Remove all user accounts</li>
                                    <li>Cancel your active subscription (no refund)</li>
                                    <li>Permanently erase company data after 30 days</li>
                                </ul>
                            </div>

                            <div className="deactivate-confirm-field">
                                <label>Type DEACTIVATE to confirm</label>
                                <input
                                    type="text"
                                    value={confirmText}
                                    onChange={(e) => setConfirmText(e.target.value)}
                                    placeholder="DEACTIVATE"
                                    className="settings-field-input"
                                />
                            </div>

                            <p className="deactivate-consider">
                                Consider <a href="#">downloading your data</a> before proceeding, or <a href="#">contact support</a> to discuss alternatives like pausing your subscription.
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button className="modal-btn-cancel" onClick={() => setShowDeactivateModal(false)}>Cancel</button>
                            <button
                                className="modal-btn-danger"
                                disabled={!isConfirmValid}
                                onClick={() => {/* TODO: handle deactivation */ }}
                            >
                                Permanently Deactivate
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
